<template>
  <vue-dialog :dialog-data="dialogData" @confirm="confirm">
    <el-form :model="form" label-width="auto" :rules="rules" ref="form" size="small">
      <el-form-item label="设备名" prop="name">
        <el-input v-model.trim="form.name" clearable/>
      </el-form-item>
      <el-form-item label="设备型号" prop="model">
        <el-input v-model.trim="form.model" clearable/>
      </el-form-item>
      <el-form-item label="硬件平台" prop="plat">
        <el-select v-model="form.plat" filterable>
          <el-option v-for="(item, index) in platformType" :key="index" :label="item" :value="item"/>
        </el-select>
      </el-form-item>
      <el-form-item label="SN文件" prop="file">
        <upload-file v-model="form.file" suffix="txt"/>
      </el-form-item>
      <el-form-item label="自定义设备名" prop="name_x">
        <el-input v-model.trim="form.name_x" clearable placeholder="选填"/>
      </el-form-item>
      <el-form-item label="自定义设备型号" prop="model_x">
        <el-input v-model.trim="form.model_x" clearable placeholder="选填"/>
      </el-form-item>
    </el-form>
  </vue-dialog>
</template>

<script>
  import UploadFile from "@view/components/upload/UploadFile"
  import {inputEmpty, changeEmpty, checkNameModel} from "@utils/validate"
  import {platformType} from "@utils/formatList"
  export default {
    name: "ImportDevice",
    components: {UploadFile},
    props: {dialogData: Object},
    data() {
      return {
        platformType,
        form: {
          name: "",
          model: "",
          plat: "",
          file: "",
          name_x: "",
          model_x: "",
        },
        rules: {
          name: [inputEmpty("设备名"), checkNameModel()],
          model: [inputEmpty("设备型号"), checkNameModel()],
          name_x: [checkNameModel()],
          model_x: [checkNameModel()],
          plat: [changeEmpty("硬件平台")],
          file: [changeEmpty("SN文件")],
        },
      }
    },
    methods: {
      confirm() {
        this.$refs["form"].validate(async isOk => {
          if (isOk) {
            let nv = {...this.form};
            let res = await this.$Http.importDevice(nv, {}, true);
            if (res) {
              this.msgSuccess("导入成功");
              this.$emit("table-reload");
              this.dialogData.visible = false;
            }
          }
        });
      }
    }
  }
</script>

<style scoped>

</style>
